import * as React from 'react';
import { RouteComponentProps } from 'react-router';

export class NotFoundPerson extends React.Component<RouteComponentProps<{}>, {}> {
    public render() {
        const code = NotFoundPerson.getParam('code');
        return (
            <div>
                <h1>Person with code: {code} was not found</h1>
                <p>Please select person from the list</p>
            </div>
        );
    }

    static getParam(key: string): string | null {
        const params = new URLSearchParams(window.location.search);
        return params.get(key);
    }
}
